import { Injectable } from '@angular/core';
import { defaults, defaultsDeep, has, isEmpty, startsWith } from 'lodash';
import { SplunkAnalyticsService } from '../splunk-analytics/splunk-analytics-service';
import { HttpClient } from '@angular/common/http';
import { LayoutService } from '../layout/layout.service';
import { Layoutresolver } from '../layout/layout-resolver';
import { LoadTimeService } from '../LoadTimeService/load-time-service';
import { ModalHandlerService } from '../../Services/modal-factory/modal-handler';
import { ObservablesService } from '../observables/observables';
import { Router } from '@angular/router';
import { ConfigService } from '../config.service';
import { StoreService } from '../store';
import { InformationModalService } from '../information-model-factory/information-model-factory';

@Injectable({ providedIn: 'root' })
export class ActionApiService {
	request: request;
	data: StaticContentModel;
	requestQueue: any[];
	stage: string;
	action: string;
	isRunning = false;
	API_ACTION_URL: string;
	defaultOptions: any;
	ajaxInfoInterval: any;
	onSubmission: boolean;

	constructor(
		private httpClient: HttpClient,
		private LayoutService: LayoutService,
		private router: Router,
		private layOutresolver: Layoutresolver,
		private modalHandlerService: ModalHandlerService,
		private observablesService: ObservablesService,
		private loadTimeService: LoadTimeService,
		private splunkAnalyticsService: SplunkAnalyticsService,
		private storeService: StoreService,
		private configService: ConfigService,
		private informationModalService: InformationModalService
	) {
		this.requestQueue = [];
		this.API_ACTION_URL = `${this.configService.getConfig().apiBaseUrl}Interview`;
		this.defaultOptions = {
			headers: { 'Content-Type': 'application/json' }, // 'X-Bolt-SessionId': window.sessionStorage.sessionId
			withCredentials: startsWith(`${this.configService.getConfig().ENV}`, 'bolt'),
		};
	}

	async invokeAction(actionInfo: request, isRemoteAction?: boolean, requestType?: string) {
		try {
			//	this.requestType = requestType;
			if (
				actionInfo.info !== undefined &&
				actionInfo.info.action != 'InitInterview' &&
				actionInfo.info.stage != 'InitInterview'
			) {
				this.action = actionInfo.info.action;
				this.stage = this.router.routerState.snapshot.url.replace('/', '');
				actionInfo.isRemoteAction = isRemoteAction;
				const res = await this.post(this.API_ACTION_URL, actionInfo, {}, requestType);

				return res;
			}
		} catch (ex) {
			console.log(ex);
			return {};
		}
	}

	async handleResponse(res: any, splunkTimerId: string) {
		if (startsWith(res.action, 'render')) {
			clearInterval(this.ajaxInfoInterval);
			this.observablesService.showAjaxLoader.next(false);

			this.data = this.layOutresolver.resolve(res, this.LayoutService.staticLayout);
			this.LayoutService.staticLayout.next(this.data);

			this.modalHandlerService.handleModalresponse(res, this.action);

			var bridgeUrl =
				res.data.globalAttributes && res.data.globalAttributes.RegisterBridgeInfo
					? res.data.globalAttributes.RegisterBridgeInfo.RegisterBridgeURL
					: undefined;
			if (bridgeUrl) {
				var win = window.open(bridgeUrl, !res.data.globalAttributes.RegisterBridgeInfo.stage ? '_blank' : '_self');
				win.focus();
			}

			if (has(res, 'data.metadata') && res.data.metadata.page.state !== 'preloader') {
				const path = has(res, 'data.metadata.page.stage') ? `/${res.data.metadata.page.stage}` : `/`;
				if (this.isvirualPageNeeded()) {
				}
				if (this.data.data.ui.page.stage == 'TechnicalError') {
					const submissionLoaderElement = document.getElementById('submission-preloader-popup');
					if (submissionLoaderElement) {
						submissionLoaderElement.style.display = 'none'; // Hides the loader
					}
				}
				this.router.navigate([this.data.data.ui.page.stage]);
			} else if (res.action == 'page') {
				this.observablesService.showPreloader.next(true);
				if (this.isvirualPageNeeded()) {
				}
			}

			if (has(res, 'data.errors') && !isEmpty(res.data.errors)) {
				this.splunkAnalyticsService.handelErrosEvents({
					erros: res.data.errors,
					renderType: res.action,
					storeData: this.LayoutService.staticLayout.getValue(),
				});
			}

			if (res.action != 'modal' && res.action != 'popup') {
				setTimeout(() => {
					this.observablesService.pageUpdated.next({
						action: this.action,
						splunkTimerId: splunkTimerId,
						page: this.data.data.ui.page.stage,
					});
				});
			}
			this.observablesService.unlockButtons.next();
			if (this.action == 'ShowBridgeNoteModal') {
				this.observablesService.preBridgeCall.next(true);
			}
		} else if (res.action === 'redirect') {
			const { url, target = '_self' } = res.instructions;

			if (!isEmpty(url)) {
				setTimeout(() => {
					window.open(url, target);
				}, 500);
			}
			return;
		} else if (res.data && res.data.ActivateLoader) {
			this.router.navigate(['EditAddress/loader']);
		} else {
			if (
				res.data.metadata &&
				res.data.metadata.page &&
				(res.data.metadata.page.customSubmission || res.data.metadata.page.registerSubmission)
			) {
				this.onSubmission = true;
				// set interval for checking if next page is ready
				// IMPORTANT: in case server is delayed when rates recieved, ajaxInfoInterval will continue stacking requests into queue in action-api.service
				//, which will pass to rates page. Redesign of ajax logic is required to avoid this.
				this.ajaxInfoInterval = setInterval(() => {
					this.ajaxAction(res.data.metadata.page.ajaxInfo, 'page');
				}, 5000);
			}
			if (this.requestQueue.length > 0) {
				this.post(this.requestQueue[0].data, this.requestQueue[0].data.isRemoteAction);
			}

			if (res.requestType == 'fetchStateAndCity') {
				this.observablesService.fetchStateAndCity.next(res.data);
				this.data = this.layOutresolver.resolve(res, this.LayoutService.staticLayout);
				if (this.data.data.answers.page['PolicyData.HomeAutoInsurance'] === true) {
					const autoBundle: control = this.data.data.metadata.page.controls.find((control: control) => {
						return control.name === 'AutoBundle';
					});
					if (autoBundle) {
						autoBundle.visible = this.data.data.answers.page['PolicyData.PropertyAddress.State'] !== 'CA';
						this.LayoutService.renderPageFromUISubject.next(this.data);
					}
				}
			}

			if (res.requestType == 'fetchAddresses') {
				this.observablesService.fetchAddresses.next(res.data);
			}

			if (res.requestType == 'SubmissionLoaderCheckForResults' && this.stage == 'EditAddress/loader') {
				this.observablesService.SubmissionLoaderCheckForResults.next(res);
			}

			return res.data;
		}
	}

	isvirualPageNeeded() {
		if (this.data.data.ui.page.stage == this.stage) {
			return false;
		}
		return true;
	}

	async post(path, data, config = {}, requestType?: string) {
		this.requestQueue.push({
			url: path,
			data,
			method: 'POST',
			config,
			requestType,
		});
		await this.runRequest();
	}

	async runRequest() {
		if (!this.isRunning && this.requestQueue.length > 0) {
			const reqIdGtm = this.loadTimeService.beginTimeMeasure();
			const reqIdSplunk = this.loadTimeService.beginTimeMeasure();

			this.isRunning = true;
			let thisRequest = this.requestQueue.shift();
			switch (thisRequest.method) {
				case 'GET':
					const getRes = await this.httpClient
						.get(this.API_ACTION_URL, defaults(thisRequest.config, this.defaultOptions))
						.toPromise();
					thisRequest = Object.assign(thisRequest, getRes);
					break;
				case 'POST':
					const defualts = defaults(thisRequest.config, this.defaultOptions);
					if (
						thisRequest.data.info.action.includes('PreSubmissionLoader') ||
						thisRequest.data.info.action.includes('ThreeQuickQuestionsNext')
					) {
						this.sendGCPReport();
					}
					if (thisRequest.data.info.action.includes('Next')) {
						let relevantData = {};
						thisRequest.data.data = defaultsDeep(
							{},
							thisRequest.data.data,
							this.LayoutService.staticLayout.getValue().data.answers.page
						);

						Object.keys(thisRequest.data.data).forEach((element) => {
							if (document.getElementsByName(element).length > 0) {
								relevantData[element] = thisRequest.data.data[element];
								//delete thisRequest.data.data[element];
							}
							// console.log(
							// 	'element-' + element + '-' + document.getElementsByName(element),
							// 	thisRequest.data.data[element]
							// );
						});
						thisRequest.data.data = relevantData;
					} else {
						//	this.lastReqData = thisRequest.data.data;
					}
					const postRes = await this.httpClient
						.post(this.API_ACTION_URL, thisRequest.data, defualts)
						.toPromise()
						.catch((err) => {
							this.observablesService.unlockButtons.next();
							this.isRunning = false;
						});
					// 	await this.requestQueue.forEach((element) => {
					// 		console.log('element.data.data- ' + element, element.data.data);
					// 		console.log(
					// 			'this.deleteNullParamters((postRes as any).data.data)- ',
					// 			this.deleteNullParamters((postRes as any).data.data)
					// 		);
					// 		if (element.data.info.action.includes('Next')) {
					// 			//	element.data.data = this.deleteNullParamters((postRes as any).data.data);
					// 		} else {
					// 			element.data.data = Object.assign(
					// 				this.deleteNullParamters((postRes as any).data.data),
					// 				element.data.data
					// 			);
					// 		}
					// 		console.log('after- ' + element, element.data.data);
					// 		console.log('______________________________________');
					// 	});

					thisRequest = Object.assign(thisRequest, postRes);
					this.LayoutService.setGlobalAttributtesAndAddonParams(postRes);
					break;
			}
			this.isRunning = false;
			this.loadTimeService.endTimeMeasure(reqIdGtm);
			this.loadTimeService.addPoint(reqIdSplunk);

			if (
				startsWith(thisRequest.action, 'render') &&
				(this.LayoutService.staticLayout.getValue().data.metadata.page.state == 'preloader' || this.onSubmission)
			) {
				this.setGtmEvents(thisRequest, reqIdGtm);
				this.onSubmission = false;
				await this.handleResponse(thisRequest, reqIdSplunk);
				// setTimeout(() => {
				// 	if (this.action != 'ShowBridgeNoteModal' && this.action != 'PageDuration')
				// 		this.informationModalService.close();
				// }, 2000);
			} else if (this.requestQueue.length > 0) {
				this.setGtmEvents(thisRequest, reqIdGtm);
				this.handleSubscribe(thisRequest);
				this.runRequest();
			} else {
				this.setGtmEvents(thisRequest, reqIdGtm);
				await this.handleResponse(thisRequest, reqIdSplunk);
			}
		}
	}

	sendGCPReport() {
		const pgrCookieTrackingPrefIndicator = this.splunkAnalyticsService.getGpcEnabledIndicator();
		const gpcEnabledIndicator = window.navigator['globalPrivacyControl'] ? 1 : 0;
		if (gpcEnabledIndicator == 0 && pgrCookieTrackingPrefIndicator == 1) {
			this.invokeActionWithoutResponse({
				data: {},
				info: {
					action: 'UpdateConsentUsingPGRCustomerHub',
					conditions: '',
					elementSrc: '',
					stage: '',
					notRenderPage: false,
				},
			});
		}
	}

	invokeActionWithoutResponse(actionInfo: request, isRemoteAction?: boolean, requestType?: string) {
		const defualts = defaults({}, this.defaultOptions);
		this.httpClient.post(this.API_ACTION_URL, actionInfo, defualts).toPromise();
	}

	invokeActionFetchWithoutResponse(actionInfo: request, isRemoteAction?: boolean, requestType?: string) {
		fetch(this.API_ACTION_URL, {
			keepalive: true,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			credentials: startsWith(`${this.configService.getConfig().ENV}`, 'bolt') ? 'include' : 'omit',
			body: JSON.stringify(actionInfo),
		});
	}

	deleteNullParamters(obj: any) {
		Object.keys(obj)
			.filter((k) => obj[k] === null)
			.forEach((k) => delete obj[k]);
		return obj;
	}

	setGtmEvents(request, gtmTimerId) {
		const ajaxLoadTime = this.loadTimeService.calculateTimeMeasure(gtmTimerId);
		this.setInitialPageLoadLoadTime(request, ajaxLoadTime);
		setTimeout(() => {
			if (request.action.indexOf('popup') == -1 && request.sendLoadTime && ajaxLoadTime.bucket != 'ERROR') {
			}
		}, 250);
	}

	handleSubscribe(res) {
		if (res.requestType == 'fetchStateAndCity') {
			this.observablesService.fetchStateAndCity.next(res.data);
		}

		if (res.requestType == 'fetchAddresses') {
			this.observablesService.fetchAddresses.next(res.data);
		}
	}

	ajaxAction(ajaxInfo: ajaxInfo, renderType: string, elementSrc?: any) {
		if (elementSrc) {
			ajaxInfo.elementSrc = elementSrc;
		}
		this.request = Object.assign(
			{},
			{
				data: this.LayoutService.staticLayout.getValue().data.answers[renderType],
				info: ajaxInfo,
			}
		);
		return this.invokeAction(this.request, true);
	}

	setInitialPageLoadLoadTime(request, ajaxLoadTime) {
		let arr = window.location.href.split('/');
		let currentStage = arr[arr.length - 1];
		let responseStage = request.data.metadata ? request.data.metadata.page.stage : null;
		request.sendLoadTime = true;
		if (currentStage && responseStage && currentStage != responseStage) {
			request.sendLoadTime = false;
		}
	}
}
